export { default } from './manager-info';
